<template>
  <div>
    <v-row class="mt-2">
      <v-col
        v-for="(metric, index) in selectedMetrics"
        :cols="showMetricsInTwoColumns && !editMode ? 6 : 12"
        :key="metric.id"
      >
        <Metric
          class="mb-4"
          :data-testid="`${testId}-${metric.id}`"
          :isImpact="isImpact"
          :editMode="editMode"
          :revCurrency="revCurrency"
          :organizationCurrency="organizationCurrency"
          :exchangeRate="exchangeRate"
          :metric="metric"
          :required="requireFillMetric"
          @delete="handleDeleteMetric"
          @change="handleMetricChange($event, index)"
        />
      </v-col>
    </v-row>
    <AddMetric
      v-if="!emptyMetricsToSelect && editMode"
      data-testid="add-metric"
      class="mt-2"
      :data-tourid="addButtonTourId || 'revImpacts-button-addMetric'"
      :isImpact="isImpact"
      :optionsLists="metricsToSelect"
      @select="handleSelectMetric"
    />
  </div>
</template>

<script>
import _ from 'lodash'

import Metric from '@/components/Rev/Review/Metric.vue'
import AddMetric from '@/components/Rev/Review/AddMetric.vue'

export default {
  name: 'Metrics',

  components: {
    Metric,
    AddMetric,
  },

  props: {
    editMode: Boolean,
    isImpact: Boolean,
    initialMetrics: { type: Array, default: () => [] },
    metrics: { type: Array, default: () => [] },
    revCurrency: { type: String, required: true },
    organizationCurrency: { type: String, required: true },
    exchangeRate: { type: Number, required: true },
    testId: { type: String, default: '' },
    tourId: { type: String, default: '' },
    addButtonTourId: { type: String, default: '' },
    showMetricsInTwoColumns: Boolean,
    requireFillMetric: Boolean,
  },

  computed: {
    selectedMetrics() {
      return (
        this.initialMetrics.map(initialMetric => {
          const metric = this.metrics?.find(
            metric =>
              metric.id ===
              (this.isImpact ? initialMetric.id : initialMetric.type)
          )
          return {
            ...initialMetric,
            id: initialMetric?.id ?? initialMetric?.type,
            units: metric?.units ?? [],
            name: metric?.name ?? '',
            frequency: initialMetric.frequency,
          }
        }) ?? []
      )
    },

    metricsToSelect() {
      const enabledMetrics = this.isImpact
        ? this.metrics.filter(metric => metric.isEnabled)
        : this.metrics
      const unselectedMetrics = _.differenceBy(
        _.orderBy(
          enabledMetrics,
          metric => this.$i18n.t(`impacts.${metric?.name}`).toLowerCase(),
          'asc'
        ),
        this.selectedMetrics,
        'id'
      )

      if (this.isImpact) return _.groupBy(unselectedMetrics, 'type')
      if (unselectedMetrics.length > 0) return { unselectedMetrics }
      return {}
    },

    emptyMetricsToSelect() {
      return _.isEmpty(this.metricsToSelect)
    },
  },

  methods: {
    handleSelectMetric(metric) {
      this.$emit('add', metric)
      this.$emit('change', [...this.initialMetrics, metric])
    },

    handleDeleteMetric(deletedMetric) {
      const selectedMetrics = this.selectedMetrics.filter(
        metric => metric.id !== deletedMetric.id
      )
      this.$emit('delete', deletedMetric)
      this.$emit('change', selectedMetrics)
    },

    handleMetricChange(metric, index) {
      const metricsChanged = _.clone(this.selectedMetrics)
      const { id, unit, value, frequency, type } = metric
      metricsChanged[index] = this.isImpact
        ? { id, unit, value, frequency }
        : { type, unit, value, frequency }
      this.$emit('change', metricsChanged)
    },
  },
}
</script>
